import { connect } from 'react-redux';
import Modal from 'comp/modals/contact_profile';
import * as selectors from 'selectors';

const mapToProps = state => ({
  contact: selectors.getContact()
});

export default connect(mapToProps)(Modal);



// WEBPACK FOOTER //
// ./src/containers/modals/ContactProfile.js